<template>
  <BaseTag v-bind="attrs"
           v-on="$listeners">
    <div :style="indicatorStyle" />
    <slot />
    <template v-if="!disabled">
      <slot name="popButton">
        <IconSecondary v-bind="iconAttrs"
                       :style="iconStyle"
                       @click="$emit('close')"/>
      </slot>
    </template>
  </BaseTag>
</template>

<script>
  import BaseTag from '@base/base-tag'
  import IconSecondary from '@modules/icon/icon-secondary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TagBinaryStatus',
    components: {
      BaseTag,
      IconSecondary,
    },
    props: {
      disabled: { type: Boolean, required: false, default: false },
      on: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        iconAttrs: {
          content: 'close',
          fontSize: '12px',
        },
        iconStyle: {
          cursor: 'pointer',
          margin: `0 0 0 ${Layout.space.xs}`,
        },
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      attrs: function () {
        return {
          alignItems: 'center',
          backgroundColor: this.on ? this.color.availableLight(0.75) : this.color.unavailableLight(0.75),
          borderRadius: Layout.space.xs,
          display: 'flex',
          justifyContent: 'space-between',
          height: '19px',
          padding: `${Layout.space.sm}`,
        };
      },
      indicatorStyle: function () {
        return {
          backgroundColor: this.on ? '#04F06A' : '#FF2E00',
          borderRadius: '50%',
          height: '6px',
          margin: `0 ${Layout.space.xs} 0 0`,
          width: '6px',
        };
      },
    },
  };
</script>
